import { useSearchParams } from "react-router-dom";
import { AdminCoverage, AdminRequests } from "./AdminSourceRequests.tsx";
import { AdminSubscriptions } from "./AdminSubscriptions.tsx";
import { AdminSpyBots } from "./AdminSpyBots.tsx";
import { AdminPartners } from "./AdminPartners.tsx";
import { AdminApiTokens } from "./AdminApiTokens.tsx";
import { AdminPushes } from "./AdminPushes.tsx";

const tabs = [
  { id: "coverage", label: "Coverage" },
  { id: "requests", label: "Requests" },
  { id: "subscriptions", label: "Subscriptions" },
  { id: "pushes", label: "Pushes" },
  { id: "spyBots", label: "Spy Bots" },
  { id: "partners", label: "Partners" },
  { id: "apiTokens", label: "API Tokens" },
] as const;
type Tab = typeof tabs[number]["id"];

const isAdminTab = (value: string | null): value is Tab =>
  tabs.some(({ id }) => id === value);

export const AdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get("adminTab");
  const hasRequestId = Boolean(searchParams.get("requestId"));
  const tab = isAdminTab(rawTab)
    ? rawTab
    : (hasRequestId ? "requests" : "coverage");

  const setTab = (newTab: Tab) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("adminTab", newTab);
        if (newTab !== "requests") {
          next.delete("requestId");
        }
        return next;
      },
      { replace: true },
    );
  };

  return (
    <div className="px-4 py-8">
      <div className="mx-auto max-w-6xl space-y-8">
        <div className="border-b border-white/10">
          <nav className="flex gap-1">
            {tabs.map(({ id, label }) => (
              <button
                key={id}
                type="button"
                onClick={() => setTab(id)}
                className={`px-4 py-3 text-sm font-medium transition border-b-2 -mb-px ${
                  tab === id
                    ? "border-purple-500 text-white"
                    : "border-transparent text-gray-400 hover:text-white"
                }`}
              >
                {label}
              </button>
            ))}
          </nav>
        </div>

        {tab === "coverage"
          ? <AdminCoverage />
          : tab === "requests"
          ? <AdminRequests />
          : tab === "subscriptions"
          ? <AdminSubscriptions />
          : tab === "pushes"
          ? <AdminPushes />
          : tab === "spyBots"
          ? <AdminSpyBots />
          : tab === "partners"
          ? <AdminPartners />
          : <AdminApiTokens />}
      </div>
    </div>
  );
};
